import styled from 'styled-components';

const COLOR_GREY_1 = '#171716';
const COLOR_WHITE = '#fff';

export const UserContainer = styled.div`
    margin-left: 0;
    position: relative;
`;

export const UserProfile = styled.button.attrs({ type: 'button' })`
    align-items: center;
    background: none;
    border: 0;
    cursor: pointer;
    display: flex;
    gap: 12px;
    padding: 0;
`;

export const UserName = styled.span`
    color: ${COLOR_GREY_1};
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
`;

export const UserPicture = styled.picture`
    align-items: center;
    background: ${COLOR_GREY_1};
    border-radius: 50%;
    color: ${COLOR_WHITE};
    display: inline-flex;
    font-family: Roboto, sans-serif;
    font-size: 12px;
    font-weight: 700;
    height: 28px;
    justify-content: center;
    line-height: 1;
    overflow: hidden;
    width: 28px;
`;

export const UserImage = styled.img`
    height: 100%;
    object-fit: cover;
    width: 100%;
`;

export const UserProfileMenu = styled.div`
    background-color: ${COLOR_WHITE};
    border-radius: 12px;
    box-shadow:
        rgba(0, 0, 0, 0.2) 0 5px 5px -3px,
        rgba(0, 0, 0, 0.14) 0 8px 10px 1px,
        rgba(0, 0, 0, 0.12) 0 3px 14px 2px;
    list-style: none;
    margin: 0;
    padding: 8px 0;
    position: absolute;
    right: 0;
    top: 100%;
    z-index: 1;
`;

export const UserProfileMenuButton = styled.button.attrs({ type: 'button' })`
    background-color: ${COLOR_WHITE};
    border: 0;
    cursor: pointer;
    font-family: Roboto, sans-serif;
    font-size: 12px;
    font-weight: 700;
    line-height: 12px;
    min-height: 32px;
    padding: 0 24px;
    white-space: nowrap;
    width: 100%;
    text-align: left;

    :active,
    :focus,
    :hover {
        background-color: rgba(0, 0, 0, 0.04);
    }

    :disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }
`;

export const UserProfileMenuLink = styled.a`
    background-color: ${COLOR_WHITE};
    color: ${COLOR_GREY_1};
    display: block;
    font-family: Roboto, sans-serif;
    font-size: 12px;
    font-weight: 700;
    line-height: 12px;
    min-height: 32px;
    padding: 10px 24px;
    text-decoration: none;
    white-space: nowrap;

    :active,
    :focus,
    :hover {
        background-color: rgba(0, 0, 0, 0.04);
    }
`;